<template>
  <div>
    <validation-observer ref="enableDisableRules">
      <b-form>
        <h5 class="section-label mb-2 mt-2">
          {{ $t('Activate / Deactivate Transfer And Bill for Mobile & Internet Banking Channel') }}
        </h5>
        <b-row class="match-height mt-1 mb-2">
          <b-col
            md="6"
          >
            <SwitchButton
              v-model="enableDisableTransferFormData.enableLocalTransfers"
              :label="$t('Local Transfers')"
              name="enable-local-transfers"
              class="ml-6"
              :readonly="isReadonly"
            />
          </b-col>
          <b-col md="6">
            <SwitchButton
              v-model="enableDisableTransferFormData.enableInterbankTransfers"
              :label="$t('Interbank Transfers')"
              name="enable-interbank-transfers"
              class="ml-6"
              :readonly="isReadonly"
            />
          </b-col>
          <b-col
            class="mt-2"
            md="6"
          >
            <SwitchButton
              v-model="enableDisableTransferFormData.enableBillsPayment"
              :label="$t('Bills Payment')"
              name="enable-bills-payment"
              class="ml-6"
              :readonly="isReadonly"
            />
          </b-col>
        </b-row>
      </b-form>
      <FullScreenSpinner :show="showSpinner" />
    </validation-observer>
    <div class="mt-2">
      <Button
        v-if="getUserPermission('UPDATE_SECURITY_CONFIG')"
        :label="$t('Update')"
        :loading="isLoading"
        :disabled="isDisabled"
        size="lg"
        @click="handleSubmit"
      />
    </div>
  </div>
</template>

<script>
import {
  BRow, BCol, BForm,
} from 'bootstrap-vue'
import { ValidationObserver } from 'vee-validate'
import { modalMixins } from '@core/mixins/modal'
import { tableMixins } from '@core/mixins/table'
import { sweetAlert } from '@core/mixins/sweetAlert'
import { permissionMixin } from '@core/mixins/permission'
import { mapActions } from 'vuex'
import Button from '../../../../components/button/Button.vue'
import { eChannelsPermission } from '@/helpers/permissions'
import SwitchButton from '../../../../components/switch/Switch.vue'
import FullScreenSpinner from '@/views/components/spinner/FullScreenSpinner.vue'

export default {
  components: {
    BRow,
    BCol,
    BForm,
    ValidationObserver,
    SwitchButton,
    Button,
    FullScreenSpinner,
  },
  mixins: [modalMixins, tableMixins, sweetAlert, permissionMixin],

  data() {
    return {
      isLoading: false,
      isDisabled: false,
      enableDisableTransferFormData: {
        enableLocalTransfers: false,
        enableInterbankTransfers: false,
        enableBillsPayment: false,
      },
      actionType: '',
    }
  },
  mounted() {
    this.fetchEnableDisableTransfer()
  },
  methods: {
    ...mapActions({
      getFraudChecks: 'eChannels/getFraudChecksList',
      updateFruadChecks: 'eChannels/updateFraudCheckAction',
    }),
    async fetchEnableDisableTransfer() {
      try {
        this.showSpinner = true
        const response = await this.getFraudChecks({
          permission: eChannelsPermission.VIEW_SECURITY_CONFIG,
        })
        const { status, data } = response
        if (status === 200) {
          this.enableDisableTransferFormData = {
            enableLocalTransfers: data.enableLocalTransfers,
            enableInterbankTransfers: data.enableInterbankTransfers,
            enableBillsPayment: data.enableBillsPayment,
          }
        }
      } catch (error) {
        this.alertError({ text: error })
      } finally {
        this.showSpinner = false
      }
    },
    async enableDisableTransferAction() {
      try {
        this.isLoading = true
        this.isDisabled = true
        const formData = {
          enableLocalTransfers: this.enableDisableTransferFormData.enableLocalTransfers,
          enableInterbankTransfers: this.enableDisableTransferFormData.enableInterbankTransfers,
          enableBillsPayment: this.enableDisableTransferFormData.enableBillsPayment,
        }
        const response = await this.updateFruadChecks({
          formData, permission: eChannelsPermission.ENABLE_DISABLE_MOBILE_AND_INTERNETBANKING_TRANSFERS,
        })
        const { status } = await response
        if (status === 200) {
          this.hideModal('modal-lg')
          const requestText = this.$t('Your request to')
          const successText = this.$t('was successful')
          this.alertSuccess({ text: `${requestText} ${this.actionType} ${successText}` })
        }
      } catch (error) {
        this.hideModal('modal-lg')
        error.response.data.errors.forEach(responseError => {
          const requestText = this.$t('Your request to')
          const reasonText = this.$t('Transfer failed. Reason')
          this.alertError({ text: `${requestText} ${this.actionType} ${reasonText}: ${responseError.errorMessage}` })
        })
      } finally {
        this.isLoading = false
        this.isDisabled = false
      }
    },
    async handleSubmit() {
      if (this.enableDisableTransferFormData.enableLocalTransfers && this.enableDisableTransferFormData.enableInterbankTransfers && this.enableDisableTransferFormData.enableBillsPayment) {
        this.actionType = this.$t('Activate Local, Interbank Transfer And Bills Payment')
      } else if (!this.enableDisableTransferFormData.enableLocalTransfers && !this.enableDisableTransferFormData.enableInterbankTransfers && !this.enableDisableTransferFormData.enableBillsPayment) {
        this.actionType = this.$t('Deactivate Local, Interbank Transfer And Bills Payment')
      } else {
        this.actionType = this.$t('Update Transfer And Bills Payment')
      }
      this.$refs.enableDisableRules.validate().then(async success => {
        if (success) {
          const areYouSure = this.$t('Are you sure you want to')
          this.confirm(this.enableDisableTransferAction, { text: `${areYouSure} ${this.actionType}?` })
        }
      })
    },
  },
}
</script>
